'use es6';

import { createSelector } from 'reselect';
const getSmartInsights = state => typeof state.get === 'function' ? state.get('smartInsights') : state.smartInsights;
export const getSmartInsightsResult = createSelector(getSmartInsights, smartInsights => smartInsights && smartInsights.getData());
export const getSmartInsightsLoading = createSelector(getSmartInsights, smartInsights => smartInsights.isLoading());
export const getSmartInsightsLoaded = createSelector(getSmartInsights, smartInsights => smartInsights.hasEverLoaded());